import { render, staticRenderFns } from "./StopsList.vue?vue&type=template&id=fcf33d22&scoped=true&"
import script from "./StopsList.vue?vue&type=script&lang=js&"
export * from "./StopsList.vue?vue&type=script&lang=js&"
import style0 from "./StopsList.vue?vue&type=style&index=0&id=fcf33d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf33d22",
  null
  
)

export default component.exports